import React from 'react';
import { Spin } from 'antd';
import './loading.scss';

const Loading = () => {
  return (
    <div className='loading-wrapper'>
      <Spin size='large' />
    </div>
  );
};

export default Loading;
